import createIcon from '../../createIcon';

/**
 * @component @name Percent
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNy40OTgwNSAxMS4wMDIyQzkuNDI4MDUgMTEuMDAyMiAxMC45OTggOS40MzIxNyAxMC45OTggNy41MDIxN0MxMC45OTggNS41NzIxNyA5LjQyODA1IDQuMDAyMTcgNy40OTgwNSA0LjAwMjE3QzUuNTY4MDUgNC4wMDIxNyAzLjk5ODA1IDUuNTcyMTcgMy45OTgwNSA3LjUwMjE3QzMuOTk4MDUgOS40MzIxNyA1LjU2ODA1IDExLjAwMjIgNy40OTgwNSAxMS4wMDIyWk03LjQ5ODA1IDYuMDAyMTdDOC4zMjgwNSA2LjAwMjE3IDguOTk4MDUgNi42NzIxNyA4Ljk5ODA1IDcuNTAyMTdDOC45OTgwNSA4LjMzMjE3IDguMzI4MDUgOS4wMDIxNyA3LjQ5ODA1IDkuMDAyMTdDNi42NjgwNSA5LjAwMjE3IDUuOTk4MDUgOC4zMzIxNyA1Ljk5ODA1IDcuNTAyMTdDNS45OTgwNSA2LjY3MjE3IDYuNjY4MDUgNi4wMDIxNyA3LjQ5ODA1IDYuMDAyMTdaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMTguNTg4IDMuOTk3OEw0LjAwMDU1IDE4LjU4NTNMNS40MTQ3NSAxOS45OTk1TDIwLjAwMjIgNS40MTJMMTguNTg4IDMuOTk3OFoiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0xNi40OTggMTMuMDAyMkMxNC41NjggMTMuMDAyMiAxMi45OTggMTQuNTcyMiAxMi45OTggMTYuNTAyMkMxMi45OTggMTguNDMyMiAxNC41NjggMjAuMDAyMiAxNi40OTggMjAuMDAyMkMxOC40MjggMjAuMDAyMiAxOS45OTggMTguNDMyMiAxOS45OTggMTYuNTAyMkMxOS45OTggMTQuNTcyMiAxOC40MjggMTMuMDAyMiAxNi40OTggMTMuMDAyMlpNMTYuNDk4IDE4LjAwMjJDMTUuNjY4IDE4LjAwMjIgMTQuOTk4IDE3LjMzMjIgMTQuOTk4IDE2LjUwMjJDMTQuOTk4IDE1LjY3MjIgMTUuNjY4IDE1LjAwMjIgMTYuNDk4IDE1LjAwMjJDMTcuMzI4IDE1LjAwMjIgMTcuOTk4IDE1LjY3MjIgMTcuOTk4IDE2LjUwMjJDMTcuOTk4IDE3LjMzMjIgMTcuMzI4IDE4LjAwMjIgMTYuNDk4IDE4LjAwMjJaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Percent = createIcon('Percent', [
  [
    'path',
    {
      d: 'M7.49805 11.0022C9.42805 11.0022 10.998 9.43217 10.998 7.50217C10.998 5.57217 9.42805 4.00217 7.49805 4.00217C5.56805 4.00217 3.99805 5.57217 3.99805 7.50217C3.99805 9.43217 5.56805 11.0022 7.49805 11.0022ZM7.49805 6.00217C8.32805 6.00217 8.99805 6.67217 8.99805 7.50217C8.99805 8.33217 8.32805 9.00217 7.49805 9.00217C6.66805 9.00217 5.99805 8.33217 5.99805 7.50217C5.99805 6.67217 6.66805 6.00217 7.49805 6.00217Z',
      key: '6ld2sz',
    },
  ],
  [
    'path',
    {
      d: 'M18.588 3.9978L4.00055 18.5853L5.41475 19.9995L20.0022 5.412L18.588 3.9978Z',
      key: 'fgud93',
    },
  ],
  [
    'path',
    {
      d: 'M16.498 13.0022C14.568 13.0022 12.998 14.5722 12.998 16.5022C12.998 18.4322 14.568 20.0022 16.498 20.0022C18.428 20.0022 19.998 18.4322 19.998 16.5022C19.998 14.5722 18.428 13.0022 16.498 13.0022ZM16.498 18.0022C15.668 18.0022 14.998 17.3322 14.998 16.5022C14.998 15.6722 15.668 15.0022 16.498 15.0022C17.328 15.0022 17.998 15.6722 17.998 16.5022C17.998 17.3322 17.328 18.0022 16.498 18.0022Z',
      key: '1ijb6a',
    },
  ],
]);

export default Percent;
